import $ from 'jquery';
import 'superfish';

/*************** Main Menu ***************/
const search_search = $('#block-dr-foundations-search');
const main_menu_js = $('#main_menu_js');

$(main_menu_js).superfish({
  delay: 500,
  speed: 100,
});

$(main_menu_js).find('a[href="/search/node"]').on('click', function(event) {
  event.preventDefault();
  search_search.toggleClass('active');
  search_search.find('.form-search').focus();
});

$(main_menu_js).find('li').mouseenter(function() {
  if ( $(this).offset().left + $(this).outerWidth() + 200 > $(window).width() ){
    $(this).addClass('opens-left').removeClass('opens-right');
  } else {
    $(this).addClass('opens-right').removeClass('opens-left');
  }
});

/*************** Quick Links Menu ***************/
$('#quick_links_js').superfish({
  delay: 500,
  speed: 100,
});

$('#quick_links_js').find('a[href="#quick_links"]').on('click', function(event) {
  event.preventDefault();
});
